import React from 'react';
import ReactDOM from 'react-dom';

class HelpfulnessVotesComponent extends React.Component {
    constructor(props) {
        super(props);

        const helpfulness = props.helpfulness > 0 ? `+${props.helpfulness}` : props.helpfulness;
        this.state = {helpfulness: helpfulness, loading: false, helpfulnessText: props.helpfulnessText};
    }

    vote(yesNo) {
        this.setState({loading: true});
        const url = `/helpfulness/${this.props.model}/${this.props.reviewId}/${yesNo}`;
        $.ajax(url, {
            success: rs => this.setState({helpfulness: rs}),
            complete: () => this.setState({loading: false})
        });
    }

    render() {
        return (
            <span>
                    <span className="helpful-count text-sm muted">
                        <span>{this.state.helpfulnessText}&nbsp;</span>
                        <span className={this.props.showCount ? '' : 'd-none'}>
                            (<span className="rating">
                            {this.state.loading ? <img src="/media/images/worker.gif"/> : this.state.helpfulness}
                            </span>)
                        </span>
                    </span>&nbsp;
                <a className="rate vote-up btn btn-blue btn-default"
                   onClick={() => this.vote('yes')}>
                        <span>Yes&nbsp;<i className="fa fa-thumbs-up"></i></span>
                    </a>&nbsp;
                <a className="rate vote-down btn-blue btn btn-default"
                   onClick={() => this.vote('no')}>
                        <span>No&nbsp;<i className="fa fa-thumbs-down"></i></span>
                    </a>
                </span>
        );
    }
}

export function initHelpfulnessVotes  () {
    for (let element of document.querySelectorAll('span.helpfulness-yesno')) {
        const reviewId = element.getAttribute('data-review-id');
        const model = element.getAttribute('data-model');
        const helpfulness = element.getAttribute('data-helpfulness');
        const showCount = element.getAttribute('data-show-count');
        const helpfulnessText = element.getAttribute('data-helpfulness-text') || 'Helpful?';

        ReactDOM.render(
            <HelpfulnessVotesComponent
                reviewId={reviewId}
                helpfulness={helpfulness}
                model={model}
                showCount={showCount}
                helpfulnessText={helpfulnessText}/>,
            element
        );
    }
};
